import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getUnits, deleteUnits } from '../../../Utility/Api';  // Import your API functions
import UnitForm from './form';
import { Deletemodel } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { useLocation } from 'react-router-dom';

const Units_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [units, setUnits] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const unitsPerPage = 200;

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setUnits(response.data.data);
        console.log("units", response.data.data)
      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };

  const openModal = (unit = null) => {
    setSelectedUnit(unit);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteUnits(deleteID);
      toast.success('Unit deleted successfully');
      fetchUnits();
      showDeleteModal(false);
    } catch (error) {
      console.error('Error deleting unit:', error);
      // toast.error('Error deleting unit');
    }
  };

  const handleDeleteModal = (ID) => {
    showDeleteModal(true);
    setDeleteID(ID);
  };

  const indexOfLastUnit = currentPage * unitsPerPage;
  const indexOfFirstUnit = indexOfLastUnit - unitsPerPage;
  const currentUnits = units.slice(indexOfFirstUnit, indexOfLastUnit);
  const totalPages = Math.ceil(units.length / unitsPerPage);

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Units List</h6>
          {!readonly && <button
            type="button"
            onClick={() => openModal()}
            className="btn btn-primary mb-0"
            style={{ fontFamily: "poppins" }}>
            Add Unit
          </button>}
        </div>
        <hr className='mt-1' />

        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: "100%", fontFamily: "poppins" }}>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Units</th>
                    {!readonly && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {currentUnits.map((unit, index) => (
                    <tr key={unit.id}>
                      <td>{(currentPage - 1) * unitsPerPage + index + 1}</td>
                      <td>{unit.title}</td>
                      {!readonly && <td>
                        <img
                          src='/assets/images/icons/edit.png'
                          onClick={() => openModal(unit)}
                          height={"20px"}
                          alt="Edit"
                        />
                        <img
                          src='/assets/images/icons/delete.png'
                          className="mx-1"
                          onClick={() => handleDeleteModal(unit.id)}
                          height={"20px"}
                          alt="Delete"
                        />
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {deleteModal && (
        <Deletemodel
          setShowModal={showDeleteModal}
          handleDelete={handleDelete}
        />
      )}
      {showModal && (
        <UnitForm
          unit={selectedUnit}
          closeModal={() => setShowModal(false)}
          refreshList={fetchUnits}
        />
      )}
    </div>
  );
};

export default Units_list;
